import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { ResponseInterface } from 'src/app/core/interfaces/response-interface';
import { environment } from 'src/environments/environment';

export interface User {
  name: string;
  email: string;
}
export interface Command {
  value: string;
  type: string;
  protocol: string | undefined;
  description: string;
  disabled: boolean;
  usage_count?: number;
}

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  user: any;
  private userCache$?: Observable<User[]>;

  constructor(private http: HttpClient) {
  }

  getAll(): Observable<User[]> {
    if (!this.userCache$) {
      this.userCache$ = this.http.get<User[]>(environment.apiUrl + `/api/user`).pipe(
        shareReplay(1)
      );
    }
    return this.userCache$;
  }

  clearUserCache(): void {
    this.userCache$ = undefined;
  }
  getCommands(): Observable<any> {
    return this.http.get<any>(environment.apiUrl + `/api/command_trackers`);
  }

  public getUsers(currentPage: string): Observable<User> {
    //console.log(environment.apiUrl , currentPage);
    return this.http.get<User>(environment.apiUrl + 'clientes?page=' + currentPage);
    // .map(res => res.json());
  }

  public async setUserInLocalStorage() {
    await this.http.get<ResponseInterface>(`${environment.apiUrl}/api/user`)
      .toPromise()
      .then(res => {
        localStorage.setItem('user_id', res.data.id)
      });
  }
}
